import publicUrl from 'utils/publicUrl';

const account = {
  displayName: 'Jaydon Frankie',
  email: 'demo@minimals.cc',
  photoURL: publicUrl('/static/mock-images/avatars/avatar_default.jpg')
};

export default account;
